// -----------------------------
// Jours (UI friendly)
// -----------------------------
export const DAY_NAMES = [
  'Lundi',
  'Mardi',
  'Mercredi',
  'Jeudi',
  'Vendredi',
  'Samedi',
  'Dimanche'
]

export const DAY_NAMES_SHORT = [
  'Lun',
  'Mar',
  'Mer',
  'Jeu',
  'Ven',
  'Sam',
  'Dim'
]

// JS (0 = dimanche) → index LUNDI FIRST
export const JS_TO_INDEX = {
  0: 6, // Dimanche
  1: 0, // Lundi
  2: 1,
  3: 2,
  4: 3,
  5: 4,
  6: 5
}

// index → nom FR
export const INDEX_TO_DAY = DAY_NAMES

// -----------------------------
// Defaults
// -----------------------------
export const DEFAULT_OPEN_DAYS = [0,1,2,3,4,5,6]
export const DEFAULT_ONLINE_ORDER_DAYS = [1,2,3,4,5]

// -----------------------------
// Helpers
// -----------------------------
function toMinutes(hhmm) {
  if (!hhmm) return null
  const [h, m] = hhmm.split(':').map(Number)
  return h * 60 + m
}

function formatMinutes(mins) {
  if (mins <= 0) return "moins d’une minute"
  const h = Math.floor(mins / 60)
  const m = mins % 60
  if (h === 0) return `${m} min`
  if (m === 0) return `${h} h`
  return `${h} h ${m} min`
}

// -----------------------------
// MAIN
// -----------------------------
export function getOpeningStatus(date = new Date(), options = {}) {
  const jsDay = date.getDay()
  const indexDay = JS_TO_INDEX[jsDay]
  
  const now = date.getHours() * 60 + date.getMinutes()

  const {
    openDays = DEFAULT_OPEN_DAYS,
    onlineOrderDays = DEFAULT_ONLINE_ORDER_DAYS,
    openingHours = {},
    onlineOrderHours = {}
  } = options

  const todayOpening = openingHours[indexDay]
  const todayOnline = onlineOrderHours[indexDay]

  const openTime = toMinutes(todayOpening?.open) ?? 17 * 60 + 30
  const closeTime = toMinutes(todayOpening?.close) ?? 21 * 60
  const lastOrderTime = toMinutes(todayOnline?.lastOrder) ?? 20 * 20 + 20

  const isOpen =
    openDays.includes(indexDay) &&
    now >= openTime &&
    now < closeTime

  const isOnlineOrderOpen =
    onlineOrderDays.includes(indexDay) &&
    now >= openTime &&
    now < lastOrderTime

  let label = 'Fermé'
  let detail = ''

  if (isOpen) {
    label = 'Ouvert maintenant'
    detail = `Ferme dans ${formatMinutes(closeTime - now)}`
  } else if (now < openTime) {
    detail = `Ouvre dans ${formatMinutes(openTime - now)}`
  } else {
    detail = 'Fermé pour le moment'
  }

  return {
    isOpen,
    isOnlineOrderOpen,
    label,
    detail,
    times: { openTime, closeTime, lastOrderTime }
  }
}